import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImportData from './components/ImportData';
import ImportHistory from './components/ImportHistory';
import ImportDsRequestService from '../../services/importDsRequest.service';


export default function ImportDsRequest() {
    const { t } = useTranslation(['import-ds-request']);
    const [result, setResult] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 'importDate',
        sd: 'desc',
        // total: 0,
    });
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        let interval = setInterval(() => {
            if (isUploading) onSearch(currentPage);
        }, 10000);
        return () => {
            clearInterval(interval);
        };
    }, [isUploading, currentPage]);

    const onSearch = async (currentPage) => {
        setLoadingTable(true);
        try {
            const payload = {
                p: currentPage.p,
                ps: currentPage.ps,
                s: currentPage.s,
                sd: currentPage.sd,
            };
            const { data } = await ImportDsRequestService.ImportHistory(payload);
            setLoadingTable(false);
            if (data.resultData) {
                const isUploading = data.resultData.result.find(
                    (s) => s.status === 'Uploading'
                );
                if (isUploading) {
                    setIsUploading(true);
                } else {
                    setIsUploading(false);
                }
                console.log("data.resultData.result", data.resultData)
                setResult(data.resultData.result);
                setCurrentPage({
                    ...payload,
                    p: data.resultData.page,
                    ps: data.resultData.pageSize,
                    total: data.resultData.total,
                });
            }
        } catch (error) {
            setLoadingTable(false);
            console.log(error);
        }
    };

    useEffect(() => {
        onSearch({ p: 1, ps: 10, s: 'importDate', sd: 'desc' });
    }, []);

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            p: pagination.current,
            ps: pagination.pageSize,
            s: sorter && sorter.order ? sorter.columnKey : 'importDate',
            sd:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'desc',
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        onSearch(pageValues);
    };

    const paginationProps = {
        current: parseInt(currentPage.p),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    return (
        <>
            <div className="title ">{t('Import Data Subject Request')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Subject 360')} /{' '}
                </span>
                <span> {t('Import Data Subject Request')}</span>
            </div>
            <div className="grid grid-cols-1 gap-4 mt-6">
                <div className="p-8 bg-white rounded-md">
                    <ImportData currentPage={currentPage} onSearch={onSearch} />
                </div>
                <div className="p-8 bg-white rounded-md">
                    <ImportHistory
                        loadingTable={loadingTable}
                        result={result}
                        onPageChange={onPageChange}
                        paginationProps={paginationProps}
                    />
                </div>
            </div>
        </>
    );
}
